import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "analysis",
  initialState: {
    heatMap: null,
    passiveLoad: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    heatmapStart: (state) => {
      state.isFetching = true;
    },
    heatmapSuccess: (state, action) => {
      state.isFetching = false;
      state.heatMap = action.payload;
    },
    heatmapFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    passiveLoadStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    passiveLoadSuccess: (state, action) => {
      state.isFetching = false;
      state.passiveLoad = action.payload;
      state.error = false;
    },
    passiveLoadFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  heatmapStart,
  heatmapSuccess,
  heatmapFailure,
  passiveLoadStart,
  passiveLoadSuccess,
  passiveLoadFailure,
} = dataSlice.actions;
export default dataSlice.reducer;
